import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Service from "@/pages/Service";
import Maintenance from "@/pages/Maintenance";
import Hire from "@/pages/Hire";
import Sale from "@/pages/Sale";
import ForkliftDetail from "@/pages/ForkliftDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import BookService from "@/pages/BookService";
import BookingConfirmation from "@/pages/BookingConfirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Link } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import MyBookings from "@/pages/MyBookings";
import Careers from "@/pages/Careers";
import SafetyInspection from "@/pages/SafetyInspection";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { CustomerAuthProvider } from "@/lib/customerAuth";

function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <div className="font-display text-7xl md:text-9xl font-extrabold text-[#D71920]">404</div>
      <h1 className="font-display text-3xl md:text-4xl uppercase mt-4">Page not found</h1>
      <p className="mt-4 text-[#555]">The page you're looking for may have moved. Try one of the links below.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="ff-btn-primary">Return Home</Link>
        <Link to="/book-service" className="ff-btn-dark">Book a Service</Link>
        <Link to="/forklifts-for-sale" className="ff-btn-ghost">Forklifts for Sale</Link>
      </div>
    </div>
  );
}

function AppRouter() {
  const loc = useLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/forklift-service-brisbane" element={<Service />} />
        <Route path="/forklift-maintenance-brisbane" element={<Maintenance />} />
        <Route path="/forklift-hire-brisbane" element={<Hire />} />
        <Route path="/forklifts-for-sale" element={<Sale />} />
        <Route path="/forklifts/:slug" element={<ForkliftDetail />} />
        <Route path="/about-forkfix" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book-service" element={<BookService />} />
        <Route path="/booking-confirmation/:ref" element={<BookingConfirmation />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/forklift-safety-inspection" element={<SafetyInspection />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Layout />}>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <CustomerAuthProvider>
          <AppRouter />
        </CustomerAuthProvider>
      </BrowserRouter>
    </div>
  );
}
